import type { MenuProps } from "@mantine/core";
import { Menu as MantineMenu } from "@mantine/core";

import { MenuDropdown } from "./MenuDropdown";
import { MenuItem } from "./MenuItem";
import { MenuTarget } from "./MenuTarget";

/**
 * Wrapper around Mantine's Menu that disables automatic ARIA role attributes
 * on the target element. Mantine sets `aria-controls` pointing to a dropdown
 * ID that doesn't exist in the DOM until the menu opens, causing an
 * `aria_id_unique` WCAG 2.2 violation. By passing `withRoles={false}`, we
 * prevent this, and our custom MenuTarget re-adds the correct ARIA attributes
 * conditionally (only setting `aria-controls` when the menu is open).
 */
export function Menu(props: MenuProps) {
  return <MantineMenu {...props} withRoles={false} />;
}

Menu.Target = MenuTarget;
Menu.Dropdown = MenuDropdown;
Menu.Item = MenuItem;
Menu.Label = MantineMenu.Label;
Menu.Divider = MantineMenu.Divider;
Menu.Sub = MantineMenu.Sub;
